import {
  createStore
} from "vuex";
import {
  fetch,
  get,
  set
} from "../utilities/vuex";

export default createStore({
  state: {
    products: [],
    solutions: [],
    languages: [],
    productSolutions: [],
    solutionCasings: [],
    casingLinks: [],
    casingFilters: [],
    cards: [],
    casings: [],
    selectedSolution: {},
    selectedProduct: {},
    selectedLanguage: {},
    selectedCasing: {},
    selectedFeatures: {},
    selectedBenefits: {},
    activeCasings: [],
    selectedLinks: [],
    offerCasings: [],
    offerEmail: '',
    offerCompany: '',
    offerPhone: '',
    offerName: '',
    agreeAll: false,
    agreeProcessing: false,
    agreePhone: false,
    agreeEmail: false
  },
  mutations: {
    products: set("products"),
    solutions: set("solutions"),
    setSelectedSolution: set("selectedSolution"),
    setSelectedCasing: (state, casing) => {
      set("selectedCasing")(state, casing);

      //Set links 
      var links = (
        state.casingLinks.find((x) => x.casingId === casing.id) || {
          links: [],
        }
      ).links.map((x) => {
        var casing = {
          ...state.casings.find((z) => z.id === x),
        };
        return casing;
      });

      set("selectedLinks")(state, links);
      //end set links  
    },
    setSelectedProduct: set("selectedProduct"),
    setSelectedLanguage: set("selectedLanguage"),
    productSolutions: set("productSolutions"),
    solutionCasings: set("solutionCasings"),
    casingLinks: set("casingLinks"),
    casingFilters: set("casingFilters"),
    languages: set("languages"),
    cards: set("cards"),
    casings: set("casings"),
    setSelectedFeatures: set("selectedFeatures"),
    setSelectedBenefits: set("selectedBenefits"),
    setActiveCasings: set("activeCasings"),
    setSelectedLinks: set("selectedLinks"),
    offerName: set('offerName'),
    offerCompany: set('offerCompany'),
    offerPhone: set('offerPhone'),
    offerEmail: set('offerEmail'),
    offerCasings: set('offerCasings'),
    agreeAll: set('agreeAll'),
    agreeProcessing: set('agreeProcessing'),
    agreePhone: set('agreePhone'),
    agreeEmail: set('agreeEmail'),
  },
  actions: {
    fetchProducts: fetch("products"),
    fetchSolutions: fetch("solutions"),
    fetchProductSolutions: fetch("productSolutions", "assets/data"),
    fetchSolutionCasings: fetch("solutionCasings", "assets/data"),
    fetchCasingLinks: fetch("casingLinks", "assets/data"),
    fetchCasingFilters: fetch("casingFilters", "assets/data"),
    fetchLanguages: fetch("languages", "assets/languages"),
    fetchCards: fetch("cards"),
    fetchCasings: (store, payload) => {
      fetch("casings")(store, payload).then(x => {
        var src = x.source.map(y => {
          return {
            name: y.name,
            id: y.id,
            selected: false,
            title: y.title
          }
        });
        set('offerCasings')(store.state, src);
      });
    },
  },
  getters: {
    offerCompany: get('offerCompany'),
    offerName: get('offerName'),
    offerPhone: get('offerPhone'),
    offerEmail: get('offerEmail'),
    agreeAll: get('agreeAll'),
    agreeProcessing: get('agreeProcessing'),
    agreePhone: get('agreePhone'),
    agreeEmail: get('agreeEmail'),
    showOfferRequest: (state) => (viewName) => {
      if (viewName === "casings" && state.selectedCasing.id && state.selectedCasing.variant === "benefits") return true;
      if (viewName === "features" && state.selectedCasing.id) return true;
      return false;
    },
    showOurRecommendation: (state) => (viewName) => {
      if (viewName === "casings" && state.selectedCasing.id && state.selectedCasing.variant === "features") return true;
      return false;
    },
    showGoBack: (state) => (viewName) => {
      if (viewName === "languages") return false;
      if (viewName === "thank-you") return false;
      return true;
    },
    showLogo: (state) => (viewName) => {
      if (viewName === "languages") return false;
      if (viewName === "thank-you") return false;
      return true;
    },
    showSubmit: (state) => (viewName) => {
      if (viewName === "meeting") return true;
      if (viewName === "offer-request") return true;
      return false;
    },
    layout: (state) => (viewName) => {
      if (viewName === "finder") return "align-items-start justify-content-start";
      if (viewName === "casings") return "align-items-start justify-content-start";
      return "align-items-center justify-content-center";
    }
  },
  modules: {},
});